import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=6322a6ce"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=6322a6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports